import React from 'react';
import { ImgStore } from '../../elements/ImgStore/ImgStore';

import "./Background.scss";

export const Background = ()=>{
    return (
        <section className="Background">
            <ImgStore src="bgSpaceGrid.png" alt=""/>
        </section>
    );
}

export default Background;
